import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTrashBin16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconTrashBin16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M6.5 2h3a.5.5 0 0 1 .5.5V3H6v-.5a.5.5 0 0 1 .5-.5M5 3v-.5A1.5 1.5 0 0 1 6.5 1h3A1.5 1.5 0 0 1 11 2.5V3h2.5a.5.5 0 0 1 0 1H13v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a.5.5 0 0 1 0-1zM4 4v8a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4zm2 7V6a.5.5 0 0 1 1 0v5a.5.5 0 0 1-1 0m3-5v5a.5.5 0 0 0 1 0V6a.5.5 0 0 0-1 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTrashBin16);
